import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { ME_OWNER } from "../../actions/queries";
import { useNavigate, Link } from "react-router-dom";
import NavbarAccount from "../Layout/Navbar_account";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import editElem from "../../utils/editElem";
import { FrontCard, BackCardExplore, BackCardWallet } from "../Cards";


import {
  faArrowLeft,
  faPhone,
  faMapMarkerAlt,

  faTrash,
  faInfo,
  faHeart,
  faPlus,
  faTimes,
  faGift,
  faChevronRight,
  faQrcode,
  faEye,
  faPen,
  faHourglassStart,

  faChartBar,
  faTrophy,
  faPlaneDeparture,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

const MyAccountPage = () => {
  const navigate = useNavigate();
  const [cardInfo, setCardInfo] = useState(false);
  const [cardInfo2, setCardInfo2] = useState(false);

  // get owner profile with "query" "meOwner"
  const { loading, error, data } = useQuery(ME_OWNER);
  let name = "",
    displayName = "",
    email = "",
    // password = "",
    logo = "",
    color = "",
    textColor = "",
    phone = "",
    // siret = "",
    streetNb = "",
    streetName = "",
    postalCode = "",
    city = "",
    addresses = "",
    cards = [],
    offer = "0",
    offerMsgs = ";!#;!#;!#",
    commerceType = "",
    isActive = "",
    profileCompleted = false;
  if (loading)
    return (
      <div className="loaderParent">
        <div className="loader"></div>
      </div>
    );
  else if (error || !data.meOwner.email) {
    console.log('error', error)

    sessionStorage.removeItem("loggedIn");
    navigate("/login");
  } else {
    name = data.meOwner.name;
    displayName = data.meOwner.displayName;
    email = data.meOwner.email;
    logo = data.meOwner.logo;
    color = data.meOwner.color;
    textColor = data.meOwner.textColor;
    phone = data.meOwner.phone;
    streetNb = data.meOwner.streetNb;
    streetName = data.meOwner.streetName;
    postalCode = data.meOwner.postalCode;
    city = data.meOwner.city;
    addresses = data.meOwner.addresses;
    offer = data.meOwner.offer;
    offerMsgs = data.meOwner.offerMsgs;
    commerceType = data.meOwner.commerceType;
    cards = data.meOwner.cards;
    isActive = data.meOwner.isActive;
    if (
      name &&
      email &&
      addresses &&
      color &&
      textColor &&
      logo &&
      offer &&
      commerceType
    )
      profileCompleted = true;
  }

  const squaresRow1 = [];
  const squaresRow2 = [];
  const squaresRow3 = [];
  const offer10squares1 = offer == 1;
  const offer10squares2 = offer == 2;
  const offer10squares3 = offer == 3;
  const offer15squares = offer == 5;
  const offer15squares2 = offer == 6;
  let size = offer15squares || offer15squares2 ? "3.3rem" : "4rem";

  for (let i = 0; i < 5; i++) {
    if (logo && (i == 0 || i == 1 || i == 2))
      squaresRow1.push(
        <img
          key={i}
          className="square sq"
          style={{ height: size, width: size }}
          src={logo}
          alt=""
        ></img>
      );
    else
      squaresRow1.push(
        <div
          key={i}
          className="cardSquare"
          style={{
            border: `solid ${textColor || "#000000"}`,
            height: size,
            width: size,
          }}
        >
          {(offer15squares || offer15squares2 || offer10squares1) && i == 4
            ? "%"
            : ""}
        </div>
      );
  }
  for (let i = 0; i < 5; i++) {
    squaresRow2.push(
      <div
        key={i * 2}
        className="cardSquare"
        style={{
          border: `solid ${textColor}`,
          
          
          fontSize:
            offer15squares || offer15squares2 || offer10squares3
              ? "2rem"
              : "1.2rem",
          height: size,
          width: size,
        }}
      >
        {(offer15squares || offer15squares2 || offer10squares3) && i == 4
          ? "%"
          : ""}
        <span
          key={i * 2}
          style={{
            color: textColor,
            fontWeight: "bold",
          }}
        >
          {(offer10squares1 || offer10squares2) && i == 4 ? "FREE" : ""}
        </span>
      </div>
    );
  }
  if (offer15squares || offer15squares2)
    for (let i = 0; i < 5; i++) {
      squaresRow3.push(
        <div
          key={i * 3}
          className="cardSquare"
          style={{
            border: `solid ${textColor}`,
            fontSize: offer15squares ? "1rem" : "2rem",
            
            height: size,
            width: size,
          }}
        >
          <span
            key={i * 3}
            style={{
              color: textColor,
              fontWeight: offer15squares ? "bold" : "normal",
            }}
          >
            {offer15squares && i == 4
              ? "FREE"
              : offer15squares2 && i == 4
                ? "%"
                : ""}
          </span>
        </div>
      );
    }

  const defaultOfferMsgs = [
    "Offre",
    "10ème conso gratuite et réduction sur la 5ème",
    "10ème conso gratuite",
    "Réduction sur la 10ème conso",
    "11ème conso gratuite",
    "15ème conso gratuite et résduction sur la 5ème et la 10ème",
    "Réduction sur la 5ème, 10ème & 15ème conso",
  ];

  const commerceTypes = [
    "Type",
    "Restauration",
    "Salon de coiffure",
    "Salle de sport",
    "Services",
    "Autre",
  ];

  const closeModal = () => {
    editElem(".overlay", "opacity", "0");
    setTimeout(() => {
      editElem(".overlay", "visibility", "hidden");
    }, 500);
    editElem(".addressModal", "width", "0");
    editElem(".addressModalContent", "opacity", "0");
    editElem(".cardsModal", "width", "0");
    editElem(".cardsModalContent", "opacity", "0");
  };

  const showModal = (type) => {
    editElem(".overlay", "opacity", ".6");
    editElem(".overlay", "visibility", "visible");
    let width = "45%";
    if (window.screen.width < 901) width = "100%";

    if (type == "cards") {
      editElem(".cardsModal", "width", width);
      setTimeout(() => {
        editElem(".cardsModalContent", "opacity", "1");
      }, 300);
    } else {
      // type == qrcode

      editElem(".addressModal", "width", width);
      setTimeout(() => {
        editElem(".addressModalContent", "opacity", "1");
      }, 300);
    }
  };

  const buildModalAddress = (addresses) => {
    let html;
    addresses.split(";!#").forEach((address, idx) => {
      document.querySelector("#modalAddresses").insertAdjacentHTML(
        "beforeend",
        `
            <a class="modalAddress" href="/mon-compte/qrcode?address=${idx}idx"><p>${address.split("|")[0]} ${address.split('|')[1]}, ${address.split('|')[2]} ${address.split('|')[3]}</p></a>
          `
      );
    });
    return html;
  };

  document.title = "Carte Verte : Mon compte";
  console.log('title', name)
  return !name ? (
    <div></div>
  ) : (
    <div id="accountPage">
      <div className="overlay" onClick={closeModal}></div>
      <div className="addressModal">
        <div className="addressModalContent">
          <FontAwesomeIcon
            id="modalClose"
            icon={faArrowLeft}
            onClick={closeModal}
            style={{
              fontSize: "2rem",
              margin: "1.5rem 0 0 3rem",
              cursor: "pointer",
              alignSelf: "start"
            }}
          />
          <h2 id="modalTitle">Mes adresses</h2>
          <p id="modalAction">Choisissez une adresse : </p>
          <div id="modalAddresses"></div>
        </div>
      </div>

      {!profileCompleted ? (
        ""
      ) : (
        <div className="cardsModal">
          <div className="cardsModalContent">
            <FontAwesomeIcon
              id="modalClose"
              icon={faArrowLeft}
              onClick={closeModal}
              style={{
                fontSize: "2rem",
                margin: "1.5rem 0 0 3rem",
                cursor: "pointer",
                alignSelf: "start"
              }}
            />
            <h2 id="modalTitle">Ma carte</h2>
            <p
              style={{
                color: "var(--color-grey)",
                fontSize: "1rem",
                opacity: ".8",
                textAlign: "center",
              }}
            >
              {window.matchMedia("(pointer: coarse)").matches
                ? "Cliquez sur "
                : "Survolez "}
              la carte pour afficher le verso, ensuite cliquez sur le
              <FontAwesomeIcon
                icon={faInfoCircle}
                style={{ fontSize: "1.35rem", margin: "0 .5rem" }}
              />

              pour voir les infos.
            </p>
            <div id="bootiesCards">
              <div className="bootiesCard">
                <p
                  style={{
                    color: "var(--color-grey)",
                    fontSize: "1.2rem",
                    textAlign: "center",
                  }}
                >
                  Présentation de ma carte sur l'application Carte Verte.
                </p>

                <div className="flip-card">
                  <div className="flip-card-inner">
                    <FrontCard className="flip-card-inner"
                      color={color}
                      textColor={textColor}
                      name={name}
                      logo={logo}
                      displayName={displayName}
                    />

                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        zIndex: !cardInfo ? 999 : 9,
                      }}
                    >

                      <BackCardExplore
                        color={color}
                        textColor={textColor}
                        offerMsgs={offerMsgs}
                        defaultOfferMsgs={defaultOfferMsgs}
                        offer={offer}
                      />

                    </div>

                  </div>
                </div>
              </div>
              <div className="bootiesCard">
                <p
                  style={{
                    color: "var(--color-grey)",
                    fontSize: "1.2rem",
                    textAlign: "center",
                  }}
                >
                  Ma carte une fois ajoutée par un client à son <br />{" "}
                  portefeuille virtuel sur l'applciation Carte Verte.
                </p>

                <div className="flip-card">
                  <div className="flip-card-inner">
                    <FrontCard
                      color={color}
                      textColor={textColor}
                      name={name}
                      logo={logo}
                      displayName={displayName}
                    />
                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        zIndex: !cardInfo2 ? 999 : 9,
                      }}
                    >
                      <BackCardWallet
                        color={color}
                        textColor={textColor}
                        cardInfo2={cardInfo2}
                        squaresRow1={squaresRow1}
                        squaresRow2={squaresRow2}
                        squaresRow3={squaresRow3}
                        name={name}
                        offerMsgs={offerMsgs}
                        defaultOfferMsgs={defaultOfferMsgs}
                        offer={offer}
                      />
                    </div>
                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        opacity: cardInfo2 ? 1 : 0,
                        zIndex: cardInfo2 ? 999 : 9,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        onClick={() => setCardInfo2(false)}
                        style={{ fontSize: "1.4rem", marginRight: "1rem", alignSelf: "start" }}
                      />
                      <div className="cardInfo">
                        <div className="cardInfo_address">
                          <FontAwesomeIcon
                            icon={faMapMarkerAlt}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {addresses.split(";!#").length > 1
                              ? "Voir les adresses dans ma ville"
                              : addresses.split(";!#")[0]}
                          </div>
                        </div>
                        <div className="cardInfo_phone">
                          <FontAwesomeIcon
                            icon={faPhone}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          <div>{phone}</div>
                        </div>
                        <div className="cardInfo_offer">
                          <FontAwesomeIcon
                            icon={faGift}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          {offerMsgs.length == 6 ? (
                            <div>{defaultOfferMsgs[offer]}</div>
                          ) : (
                            <div>
                              <div>{offerMsgs.split(";!#")[0]}</div>
                              <div>{offerMsgs.split(";!#")[1]}</div>
                              <div>{offerMsgs.split(";!#")[2]}</div>
                              <div>{offerMsgs.split(";!#")[3]}</div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div id="icons" style={{ justifyContent: "center" }}>
                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={() => setCardInfo2(false)}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <p id="modalAction">Choisissez une adresse : </p> */}
          </div>
        </div>
      )}

      <NavbarAccount title={"MON COMPTE"} isActive={isActive} />

      <div id="accountContainer1">
        {!cards || cards.length == 0 ? (
          <div className="clientsNumberDiv">
            <FontAwesomeIcon
              icon={faHourglassStart}
              style={{
                fontSize: "2rem",
                color: "var(--color-primary-orange)",
              }}
            />
            <p className="clientsNumber">
              Vous n'avez pas de clients sur l'application Carte Verte pour le
              moment !
            </p>
          </div>
        ) : (
          <p className="clientsNumber">
            {
              <FontAwesomeIcon
                icon={cards.length > 100 ? faTrophy : cards.length > 50 ? faChartBar : faPlaneDeparture}
                style={{
                  fontSize: "2rem",
                  color: "var(--color-primary-orange)",
                }}
              />
            }
            <br />
            {" "} Vous avez atteint {" "}
            <span style={{ color: "var(--color-primary-orange)" }}>
              {cards.length}
            </span>{" "}
            clients sur l'application Carte Verte !
          </p>
        )}
        <div id="accountActions">
          <p>Actions</p>
          <div id="accountActionsContainer">
            <div id="accountCTAs">
              <button
                className="accountCTA"
                onClick={() => {
                  navigate("/mon-compte/modifier");
                }}
              >
                <div className="buttonContent">
                  <div className="buttonIconAction">
                    <FontAwesomeIcon
                      icon={faPen}
                      style={{
                        fontSize: "1.3rem",
                        marginRight: "2rem",
                        color: "var(--color-primary-orange)",
                      }}
                    />
                  </div>
                  <div className="buttonTextAction">
                    {!profileCompleted
                      ? "Compléter et activer mon compte"
                      : isActive
                        ? "Modifier mon profile"
                        : "Modifier et activer mon compte"}
                  </div>
                </div>
                <div className="buttonIconRight">
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: "1rem",
                      color: "var(--color-primary-orange)",
                    }}
                  />
                </div>
              </button>

              <button
                className="accountCTA cardsCTA"
                onClick={() => {
                  showModal("cards");
                }}
                disabled={!profileCompleted}
              >
                <div className="buttonContent">
                  <div className="buttonIconAction">
                    <FontAwesomeIcon
                      icon={faEye}
                      style={{
                        fontSize: "1.3rem",
                        marginRight: "2rem",
                        color: profileCompleted
                          ? "var(--color-primary-orange)"
                          : "rgba(0,0,0,.08))",
                      }}
                    />
                  </div>
                  <div className="buttonTextAction">
                    Afficher un aperçu de ma carte
                  </div>
                </div>

                <div className="buttonIconRight">
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: "1rem",
                      color: profileCompleted
                        ? "var(--color-primary-orange)"
                        : "rgba(0,0,0,.08))",
                    }}
                  />
                </div>
              </button>

              <div className="cards_tooltip tooltip">
                <span className="tooltiptext">
                  Vous devez compléter votre profile !
                </span>
              </div>

              <button
                className="accountCTA qrcodeCTA"
                style={{ marginTop: "-1.5rem" }}
                onClick={() => {
                  if (addresses.split(";!#").length < 2) {
                    window.location.href =
                      window.location.origin + "/mon-compte/qrcode";
                  } else {
                    if (!document.querySelector(".modalAddress")) {
                      buildModalAddress(addresses);
                    }
                    showModal("qrcode");
                  }
                }}
                disabled={!profileCompleted || !isActive}
              >
                <div className="buttonContent">
                  <div className="buttonIconAction">
                    <FontAwesomeIcon
                      icon={faQrcode}
                      style={{
                        fontSize: "1.5rem",
                        marginRight: "2rem",
                        color: isActive
                          ? "var(--color-primary-orange)"
                          : "rgba(0,0,0,.08))",
                      }}
                    />
                  </div>
                  <div className="buttonTextAction" >Accéder à mon code QR</div>
                </div>
                <div className="buttonIconRight">
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: "1rem",
                      color: isActive
                        ? "var(--color-primary-orange)"
                        : "rgba(0,0,0,.08))",
                    }}
                  />
                </div>
              </button>
              <div className="qrcode_tooltip tooltip">
                <span className="tooltiptext">
                  Vous devez activer votre compte !
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*
    
      

      <div id="accountContainer">
        <div id="info">
          <div id="contactInformation">
            <h1>Mes Coordonnées </h1>
            <p>
              <ion-icon name="mail" />
              <FontAwesomeIcon
                icon={faEnvelope}
                style={{
                  fontSize: "1.4rem",
                  width: "10%",
                }}
              />
              <span style={{}}>{email}</span>
            </p>
            <p style={{}}>
              <ion-icon name="location" />
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                style={{
                  fontSize: "1.4rem",

                  width: "10%",
                }}
              />
              {addresses ? (
                <span
                  style={{
                    display: "-webkit-box",
                    marginLeft: ".5rem",
                    overflow: "hidden",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                    width: "90%",
                  }}
                >
                  {addresses.split(";!#")[0]}
                </span>
              ) : (
                <span style={{ color: "var(--color-tertiary)" }}>
                  Adresse à renseigner
                </span>
              )}
            </p>
            <p style={{}}>
              <ion-icon name="call" />
              <FontAwesomeIcon
                icon={faPhone}
                style={{
                  fontSize: "1.4rem",
                  width: "10%",
                }}
              />
              {phone ? (
                <span style={{}}>{phone}</span>
              ) : (
                <span style={{ color: "var(--color-tertiary)" }}>
                  Téléphone à renseigner
                </span>
              )}
            </p>
          </div>
          <div id="cardPrototype" style={{ width: "100%" }}>
            <h1>Ma Carte</h1>
            <p style={{ alignItems: "center", display: "flex", width: "100%" }}>
              <ion-icon name="store" />
              <FontAwesomeIcon
                icon={faStoreAlt}
                style={{
                  fontSize: "1.4rem",
                  width: "10%",
                }}
              />
              {commerceType ? (
                <span style={{}}>{commerceTypes[commerceType]}</span>
              ) : (
                <span style={{ color: "var(--color-tertiary)" }}>
                  Type de commerce à renseigner
                </span>
              )}
            </p>
            <p style={{}}>
              <ion-icon name="gift" />
              <FontAwesomeIcon
                icon={faGift}
                style={{
                  fontSize: "1.4rem",
                  width: "10%",
                }}
              />
              {offer ? (
                <span style={{}}>{defaultOfferMsgs[offer]}</span>
              ) : (
                <span style={{ color: "var(--color-tertiary)" }}>
                  Offre à choisir
                </span>
              )}
            </p>
            <p>
              <ion-icon name="megaphone" />
              <FontAwesomeIcon
                icon={faBullhorn}
                style={{
                  fontSize: "1.4rem",
                  width: "10%",
                }}
              />
              {slogan ? (
                <span style={{}}>{slogan}</span>
              ) : (
                <span style={{ color: "var(--color-tertiary)" }}>
                  Slogan à renseigner
                </span>
              )}
            </p>
            <p style={{ display: "flex" }}>
              <ion-icon name="color-palette" />
              <FontAwesomeIcon
                icon={faPalette}
                style={{
                  fontSize: "1.4rem",
                  width: "10%",
                }}
              />

              {color ? (
                <span
                  style={{
                    display: "inline",
                    marginLeft: ".5rem",
                    width: "25%",
                  }}
                >
                  <span id="color" style={{ backgroundColor: color }}></span>
                  <span
                    id="color"
                    style={{ backgroundColor: textColor }}
                  ></span>
                </span>
              ) : (
                <span style={{ color: "var(--color-tertiary)" }}>
                  Couleurs à choisir
                </span>
              )}
            </p>
          </div>
          <button
            id="editAccountBtn"
            onClick={() => {
              navigate("/mon-compte/modifier");
            }}
          >
            {!profileCompleted
              ? "Compléter et activer mon compte"
              : isActive
              ? "Modifier mon profile"
              : "Modifier et activer mon compte"}
          </button>
        </div>
        <Link className="returnLink" to="/#">
          <FontAwesomeIcon
            icon={faArrowLeft}
            style={{ fontSize: "1.4rem", marginRight: "1rem" }}
          />
          Accueil
        </Link>
        <div id="booties">
          <div id="bootiesNb" className="tooltip">
            Cartes Vertes <br />
            <span>{cards ? cards.length : 0}</span>
            <span className="tooltiptext">
              Nombre de clients posséndant votre carte sur l'application Carte
              Verte.
            </span>
          </div>
          {!profileCompleted ? (
            <h2>
              Un protoype de votre carte sera affiché ici une fois vous avez
              complété votre profile
            </h2>
          ) : (
            <div id="bootiesCards">
              <div className="bootiesCard">
                <p
                  style={{
                    color: "var(--color-grey)",
                    fontSize: "1.2rem",
                    textAlign: "center",
                  }}
                >
                  Présentation de votre carte sur l'application Carte Verte.
                </p>
                <p
                  style={{
                    color: "var(--color-grey)",
                    fontSize: "1rem",
                    opacity: ".8",
                    textAlign: "center",
                  }}
                >
                  Survolez la carte pour voir le verso.
                </p>

                <div className="flip-card">
                  <div className="flip-card-inner">
                    <div
                      className="flip-card-front"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                      }}
                    >
                      <p
                        className="cardName"
                        style={{
                          display: `${displayName ? "block" : "none"}`,
                          transform: "rotate(-90deg) translate(-3.8rem, -2rem)",
                        }}
                      >
                        {name}
                      </p>
                      {logo ? (
                        <img id="cardLoadedLogo" src={logo} alt="Logo" />
                      ) : (
                        <p>Logo</p>
                      )}
                    </div>
                    {/* !cardInfo ? ( 
                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        zIndex: !cardInfo ? 999 : 9,
                      }}
                    >
                      <div id="cardSlogan" style={{ color: textColor }}>
                        {slogan.toUpperCase()}
                      </div>
                      <div id="icons">
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                        <FontAwesomeIcon
                          icon={faInfo}
                          onClick={() => setCardInfo(true)}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                        <FontAwesomeIcon
                          icon={faPhone}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                      </div>
                    </div>
                    {/* ) : ( *
                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        opacity: cardInfo ? 1 : 0,
                        zIndex: cardInfo ? 999 : 9,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        onClick={() => setCardInfo(false)}
                        style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                      />
                      <div className="cardInfo">
                        <div className="cardInfo_address">
                          <FontAwesomeIcon
                            icon={faMapMarkerAlt}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {addresses.split(";!#").length > 1
                              ? "Voir les adresses dans ma ville"
                              : addresses.split(";!#")[0]}
                          </div>
                        </div>
                        <div className="cardInfo_phone">
                          <FontAwesomeIcon
                            icon={faPhone}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          <div>{phone}</div>
                        </div>
                        <div className="cardInfo_offer">
                          <FontAwesomeIcon
                            icon={faGift}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          {offerMsgs.length == 6 ? (
                            <div>{defaultOfferMsgs[offer]}</div>
                          ) : (
                            <div>
                              <div>{offerMsgs.split(";!#")[0]}</div>
                              <div>{offerMsgs.split(";!#")[1]}</div>
                              <div>{offerMsgs.split(";!#")[2]}</div>
                              <div>{offerMsgs.split(";!#")[3]}</div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div id="icons" style={{ justifyContent: "center" }}>
                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={() => setCardInfo(false)}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bootiesCard">
                <p
                  style={{
                    color: "var(--color-grey)",
                    fontSize: "1.2rem",
                    textAlign: "center",
                  }}
                >
                  Votre carte une fois ajoutée par votre client à son <br />{" "}
                  portefeuille virtuel sur l'applciation Carte Verte.
                </p>
                <p
                  style={{
                    color: "var(--color-grey)",
                    fontSize: "1rem",
                    opacity: ".8",
                    textAlign: "center",
                  }}
                >
                  Survolez la carte pour voir le verso.
                </p>
                <div className="flip-card">
                  <div className="flip-card-inner">
                    <div
                      className="flip-card-front"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                      }}
                    >
                      <p
                        className="cardName"
                        style={{
                          display: `${displayName ? "block" : "none"}`,
                          transform: "rotate(-90deg) translate(-3.8rem, -2rem)",
                        }}
                      >
                        {name}
                      </p>

                      {logo ? (
                        <img id="cardLoadedLogo" src={logo} alt="Logo" />
                      ) : (
                        <p>Logo</p>
                      )}
                    </div>
                    * !cardInfo ? ( 
                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        zIndex: !cardInfo2 ? 999 : 9,
                      }}
                    >
                      <div id="squares">{squaresRow1}</div>
                      <div id="squares">{squaresRow2}</div>
                      <div id="squares">{squaresRow3}</div>
                      <div id="icons">
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                        <FontAwesomeIcon
                          icon={faInfo}
                          onClick={() => setCardInfo2(true)}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                        <FontAwesomeIcon
                          icon={faHeart}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                      </div>
                    </div>
                    <div
                      id="card"
                      className="flip-card-back"
                      style={{
                        backgroundColor: color,
                        color: textColor,
                        opacity: cardInfo2 ? 1 : 0,
                        zIndex: cardInfo2 ? 999 : 9,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        onClick={() => setCardInfo2(false)}
                        style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                      />
                      <div className="cardInfo">
                        <div className="cardInfo_address">
                          <FontAwesomeIcon
                            icon={faMapMarkerAlt}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {addresses.split(";!#").length > 1
                              ? "Voir les adresses dans ma ville"
                              : addresses.split(";!#")[0]}
                          </div>
                        </div>
                        <div className="cardInfo_phone">
                          <FontAwesomeIcon
                            icon={faPhone}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          <div>{phone}</div>
                        </div>
                        <div className="cardInfo_offer">
                          <FontAwesomeIcon
                            icon={faGift}
                            style={{
                              fontSize: "1.4rem",
                              marginRight: "1rem",
                            }}
                          />
                          {offerMsgs.length == 6 ? (
                            <div>{defaultOfferMsgs[offer]}</div>
                          ) : (
                            <div>
                              <div>{offerMsgs.split(";!#")[0]}</div>
                              <div>{offerMsgs.split(";!#")[1]}</div>
                              <div>{offerMsgs.split(";!#")[2]}</div>
                              <div>{offerMsgs.split(";!#")[3]}</div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div id="icons" style={{ justifyContent: "center" }}>
                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={() => setCardInfo2(false)}
                          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
                        />
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              
            </div>
          )}
          <div className="tooltip2">
            <button
              id="qrcodeBtn"
              onClick={() => {
                if (addresses.split(";!#").length < 2) {
                  window.location.href =
                    window.location.origin + "/mon-compte/qrcode";
                } else {
                  if (!document.querySelector(".modalAddress")) {
                    buildModalAddress(addresses);
                  }
                  showModal();
                }
              }}
              disabled={!profileCompleted || !isActive}
            >
              {"Accéder à mon code QR"}
            </button>
            <span className="tooltiptext2">
              Vous devez activer votre compte.
            </span>
          </div>
        </div>
      </div>
       */}
    </div>
  );
};

export { MyAccountPage as default };
